import React from 'react';

// import contentCardBg from '../../../../../../assets/contentCardImg.png';
// import quotesIcon from '../../../../../../assets/ic_Quote.png';

import './styles.scss';

const ContentCard = ({ sectionData }) => {
  const handleCardClick = e => {
    if (sectionData?.deepLink) {
      window.open(sectionData?.deepLink);
    } else {
      e.stopPropagation();
    }
  };

  return (
    <div onClick={handleCardClick} className="contentCardWrapper">
      <div
        className="contentCardImg"
        style={{ backgroundImage: `url("${sectionData?.imageUrl}")` }}
      />
    </div>
  );
};

export default ContentCard;
